import '@/utils/envHeader'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import ElementUI from 'element-ui';
// import {
// 	Message
// } from 'element-ui';
import './plugins'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/base.css'
import './assets/css/main.css'
// 全局科技风主题层（深蓝紫渐变底 + Element-UI 暗色适配），置于最后以获得覆盖权
import './assets/css/tech-theme.css'
// HUD 主题层（未来科技风：深空底+青色辉光），覆盖 tech-theme 同名规则
import './assets/css/hud-theme.css'
// 清新教育标准型视觉层：统一桌面与平板端显示，不改变现有业务逻辑
import './assets/css/education-theme.css'
// 平板、电脑与多媒体大屏响应式显示层；仅覆盖布局和尺寸，必须最后加载
import './assets/css/adaptive-display.css'
// UI 主题集中配置引擎：按 客户(corpId)/学段(position) 注入 token，详见 src/theme/
import { applyTheme } from './theme/applyTheme'
applyTheme()
import Axios from 'axios'
import Router from 'vue-router';
import Download from './utils/Download.js'
import baseFun from './utils/base/base.js'
// 引入sweiper
import AlloyFinger from 'alloyfinger'
import AlloyFingerPlugin from 'alloyfinger/vue/alloy_finger_vue'
//不用全局 要按需加载
// import * as echarts from 'echarts'
import moment from 'moment' //导入文件 时间的文件
//富文本编辑器
import VueQuillEditor from "vue-quill-editor"
// require styles 引入样式
// import "quill/dist/quill.core.css"
// import "quill/dist/quill.snow.css"
// import "quill/dist/quill.bubble.css"


//可拖动的弹框
import eldragdialog from "./utils/directive";
// 在main.js中增加判断
import FastClick from 'fastclick'
if ('ontouchstart' in window) {
	FastClick.attach(document.body);
}

// 引入vconsole（调试用，生产环境可注释）
// import VConsole from 'vconsole'
// const vConsole = new VConsole()

Vue.use(VueQuillEditor)
//引入全局变量 老师批改数据
Vue.prototype.$recorretedDatas = {};
Vue.prototype.$moment = moment; //赋值使用
// Vue.prototype.$echarts = echarts
Vue.use(AlloyFingerPlugin, {
	AlloyFinger
})
Vue.prototype.$Download = Download;
Vue.prototype.$baseFun = baseFun;
Vue.prototype.$axios = Axios
Vue.use(Router);

Vue.prototype.$bus = new Vue()
Vue.config.productionTip = false
Vue.directive('focus', {
	inserted: function (el) {
		// 处理 ElementUI 输入组件
		const input = el.querySelector('textarea') ||
			el.querySelector('input') ||
			el.querySelector('.el-input__inner')
		if (input) {
			input.focus()
		} else {
			// 普通 input 元素直接聚焦
			el.focus()
		}
	}
  })
//放抖动函数
Vue.directive('preventReClick', {
	inserted(el, binding) {
		el.addEventListener('click', () => {
			if (!el.disabled) {
				el.disabled = true
				setTimeout(() => {
					el.disabled = false
				}, binding.value || 2000)
			}
		})
	}
});
Vue.directive('eldragdialog', eldragdialog);
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
	return VueRouterPush.call(this, to).catch(err => err)
}
// 将 store 注入到 Vue 的原型上    在router.js中能使用
Vue.prototype.$store = store;
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')

